import React, { useState, useEffect, useCallback, useRef } from 'react';
import './AdminHeroCarrusel.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/hero_carrusel.php';

/* ── Icons ── */
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDrag     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="9" cy="6" r="1.5" fill="currentColor"/><circle cx="15" cy="6" r="1.5" fill="currentColor"/><circle cx="9" cy="12" r="1.5" fill="currentColor"/><circle cx="15" cy="12" r="1.5" fill="currentColor"/><circle cx="9" cy="18" r="1.5" fill="currentColor"/><circle cx="15" cy="18" r="1.5" fill="currentColor"/></svg>);
const IconImage    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/><path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrowUp  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrowDn  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 5v14M19 12l-7 7-7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const BG_OPCIONES = [
  { clase:'slide--cursos',     label:'Verde oscuro', color:'#0f3525' },
  { clase:'slide--materiales', label:'Verde claro',  color:'#d4f4e8' },
  { clase:'slide--azul',       label:'Azul',         color:'#1e3a5f' },
  { clase:'slide--rosa',       label:'Rosa',         color:'#831843' },
  { clase:'slide--morado',     label:'Morado',       color:'#3b0764' },
  { clase:'slide--negro',      label:'Negro',        color:'#111614' },
  { clase:'slide--blanco',     label:'Blanco/Gris',  color:'#f3f8f5' },
];

const POS_OPCIONES = ['center','top','bottom','left','right','top center','bottom center'];

const SLIDE_VACIO = {
  modo:'contenido', activo:true,
  tag:'', titulo:'', subtitulo:'', descripcion:'',
  items:[''],
  btn1_texto:'', btn1_link:'', btn2_texto:'', btn2_link:'',
  bg_clase:'slide--cursos',
  card:{ titulo:'', precio:'', stat:'', badge1:'', badge2:'' },
  imagen_url:'', imagen_position:'center', imagen_link:'',
};

export default function AdminHeroCarrusel() {
  const [slides,    setSlides]    = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [toast,     setToast]     = useState(null);
  const [modal,     setModal]     = useState(null);   // slide en edición (null = cerrado)
  const [form,      setForm]      = useState({});
  const [guardando, setGuardando] = useState(false);
  const [preview,   setPreview]   = useState(false);
  const [subiendo,  setSubiendo]  = useState(false);
  const [dragIdx,   setDragIdx]   = useState(null);
  const fileRef = useRef(null);

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3200); };

  /* Fetch */
  const fetchSlides = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(API + '?action=admin_list');
      const j = await r.json();
      if (j.success) setSlides(j.data || []);
      else showToast(j.message || 'Error cargando slides', 'error');
    } catch { showToast('Error de conexión', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchSlides(); }, [fetchSlides]);

  /* Abrir modal */
  function abrirNuevo() {
    setForm({ ...SLIDE_VACIO, items:[''] });
    setModal('nuevo');
    setPreview(false);
  }

  function abrirEditar(slide) {
    setForm({
      ...slide,
      items: slide.items?.length ? slide.items : [''],
      card:  slide.card || { titulo:'', precio:'', stat:'', badge1:'', badge2:'' },
    });
    setModal(slide.id);
    setPreview(false);
  }

  /* Helpers form */
  function setF(k, v) { setForm(p => ({ ...p, [k]: v })); }
  function setCard(k, v) { setForm(p => ({ ...p, card: { ...p.card, [k]: v } })); }

  function setItem(i, v) {
    const items = [...(form.items || [])];
    items[i] = v;
    setF('items', items);
  }
  function addItem()    { setF('items', [...(form.items||[]), '']); }
  function removeItem(i){ setF('items', (form.items||[]).filter((_,idx)=>idx!==i)); }

  /* Subir imagen */
  async function subirImagen(file) {
    if (!file) return;
    setSubiendo(true);
    const fd = new FormData();
    fd.append('imagen', file);
    try {
      const r = await fetch(API + '?action=subir_imagen', { method:'POST', body:fd });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setF('imagen_url', j.data.url);
      showToast('Imagen subida correctamente');
    } catch(e) { showToast(e.message, 'error'); }
    finally { setSubiendo(false); }
  }

  /* Guardar */
  async function guardar() {
    if (form.modo === 'contenido' && !form.titulo?.trim()) {
      showToast('El título es obligatorio', 'error'); return;
    }
    if (form.modo === 'imagen' && !form.imagen_url?.trim()) {
      showToast('Sube una imagen para el slide', 'error'); return;
    }
    setGuardando(true);
    try {
      const body = { ...form, id: modal === 'nuevo' ? 0 : modal };
      const r = await fetch(API + '?action=guardar', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify(body),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(modal === 'nuevo' ? 'Slide creado' : 'Slide guardado');
      setModal(null);
      fetchSlides();
    } catch(e) { showToast(e.message, 'error'); }
    finally { setGuardando(false); }
  }

  /* Toggle activo */
  async function toggleActivo(slide) {
    try {
      const r = await fetch(API + '?action=toggle_activo', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: slide.id, activo: !slide.activo }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(slide.activo ? 'Slide desactivado' : 'Slide activado');
      fetchSlides();
    } catch(e) { showToast(e.message, 'error'); }
  }

  /* Eliminar */
  async function eliminar(slide) {
    if (!window.confirm(`¿Eliminar el slide "${slide.titulo || 'Sin título'}"?`)) return;
    try {
      const r = await fetch(API + '?action=eliminar', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: slide.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Slide eliminado');
      fetchSlides();
    } catch(e) { showToast(e.message, 'error'); }
  }

  /* Mover orden */
  async function moverOrden(idx, dir) {
    const arr = [...slides];
    const targetIdx = idx + dir;
    if (targetIdx < 0 || targetIdx >= arr.length) return;
    [arr[idx], arr[targetIdx]] = [arr[targetIdx], arr[idx]];
    const items = arr.map((s,i) => ({ id:s.id, orden:i }));
    setSlides(arr);
    try {
      await fetch(API + '?action=reordenar', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items }),
      });
      showToast('Orden actualizado');
    } catch { showToast('Error al reordenar', 'error'); }
  }

  /* Drag & Drop */
  function onDragStart(e, idx) { setDragIdx(idx); e.dataTransfer.effectAllowed='move'; }
  function onDragOver(e, idx) {
    e.preventDefault();
    if (dragIdx === null || dragIdx === idx) return;
    const arr = [...slides];
    const item = arr.splice(dragIdx, 1)[0];
    arr.splice(idx, 0, item);
    setSlides(arr);
    setDragIdx(idx);
  }
  async function onDrop() {
    const items = slides.map((s,i) => ({ id:s.id, orden:i }));
    setDragIdx(null);
    try {
      await fetch(API + '?action=reordenar', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items }),
      });
      showToast('Orden guardado');
    } catch { showToast('Error al guardar orden', 'error'); }
  }

  /* Preview del slide actual */
  const bgOpc = BG_OPCIONES.find(b => b.clase === form.bg_clase) || BG_OPCIONES[0];

  return (
    <div className="ahc-page">

      {toast && (
        <div className={'ahc-toast ahc-toast--' + (toast.tipo==='ok'?'ok':'err')}>
          {toast.tipo==='ok' ? <IconCheck/> : <IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="ahc-header">
        <div>
          <h1>Hero / Carrusel de inicio</h1>
          <p>Administra los slides del banner principal de la página de inicio.</p>
        </div>
        <div className="ahc-header__actions">
          <button className="ahc-btn-ghost" onClick={fetchSlides}><IconRefresh/> Sincronizar</button>
          <button className="ahc-btn-primary" onClick={abrirNuevo}><IconPlus/> Nuevo slide</button>
        </div>
      </div>

      {/* KPIs */}
      <div className="ahc-kpis">
        <div className="ahc-kpi ahc-kpi--verde">
          <p>Total slides</p>
          <strong>{slides.length}</strong>
          <span>en el carrusel</span>
        </div>
        <div className="ahc-kpi">
          <p>Activos</p>
          <strong>{slides.filter(s=>s.activo).length}</strong>
          <span>visibles en el sitio</span>
        </div>
        <div className="ahc-kpi">
          <p>Modo contenido</p>
          <strong>{slides.filter(s=>s.modo==='contenido').length}</strong>
          <span>slides con texto</span>
        </div>
        <div className="ahc-kpi">
          <p>Modo imagen</p>
          <strong>{slides.filter(s=>s.modo==='imagen').length}</strong>
          <span>slides tipo banner</span>
        </div>
      </div>

      {/* INSTRUCCIÓN */}
      <div className="ahc-tip">
        <span>💡</span>
        <span>Arrastra los slides para reordenarlos, o usa las flechas ↑↓. Los cambios de orden se guardan automáticamente.</span>
      </div>

      {/* LISTA DE SLIDES */}
      {loading ? (
        <div className="ahc-loading">Cargando slides…</div>
      ) : slides.length === 0 ? (
        <div className="ahc-empty">
          <IconImage/>
          <p>No hay slides. Crea el primero.</p>
          <button className="ahc-btn-primary" onClick={abrirNuevo}><IconPlus/> Crear slide</button>
        </div>
      ) : (
        <div className="ahc-lista">
          {slides.map((slide, idx) => (
            <div
              key={slide.id}
              className={'ahc-slide-item ' + (!slide.activo ? 'ahc-slide-item--inactivo' : '') + (dragIdx===idx?' ahc-slide-item--dragging':'')}
              draggable
              onDragStart={e=>onDragStart(e,idx)}
              onDragOver={e=>onDragOver(e,idx)}
              onDrop={onDrop}
              onDragEnd={()=>setDragIdx(null)}
            >
              {/* Drag handle + orden */}
              <div className="ahc-slide-item__drag" title="Arrastrar para reordenar">
                <IconDrag/>
                <span className="ahc-slide-item__num">{idx+1}</span>
              </div>

              {/* Preview thumb */}
              <div className="ahc-slide-item__thumb">
                {slide.imagen_url ? (
                  <img src={slide.imagen_url} alt={slide.titulo||'Slide'}/>
                ) : (
                  <div className="ahc-slide-item__thumb-placeholder" style={{
                    background: BG_OPCIONES.find(b=>b.clase===slide.bg_clase)?.color || '#111614'
                  }}>
                    <span>{slide.modo==='imagen' ? '🖼️' : '📝'}</span>
                  </div>
                )}
                <div className="ahc-slide-item__modo-badge">
                  {slide.modo==='imagen' ? '🖼 Imagen' : '📝 Contenido'}
                </div>
              </div>

              {/* Info */}
              <div className="ahc-slide-item__info">
                <div className="ahc-slide-item__titulo">
                  {slide.titulo || <em style={{color:'#9ca3af'}}>Sin título</em>}
                </div>
                {slide.modo==='contenido' && (
                  <div className="ahc-slide-item__meta">
                    {slide.tag && <span className="ahc-tag-badge">{slide.tag}</span>}
                    {slide.btn1_texto && <span>→ {slide.btn1_link}</span>}
                  </div>
                )}
                {slide.modo==='imagen' && slide.imagen_url && (
                  <div className="ahc-slide-item__meta">
                    <span style={{fontSize:'.75rem',color:'#5a6a63'}}>{slide.imagen_url.split('/').pop()}</span>
                    {slide.imagen_link && <span>Link: {slide.imagen_link}</span>}
                  </div>
                )}
              </div>

              {/* Estado */}
              <div className="ahc-slide-item__estado">
                <button
                  className={'ahc-toggle ' + (slide.activo?'ahc-toggle--on':'ahc-toggle--off')}
                  onClick={()=>toggleActivo(slide)}
                  title={slide.activo?'Desactivar':'Activar'}
                >
                  {slide.activo ? '● Activo' : '○ Inactivo'}
                </button>
              </div>

              {/* Flechas orden */}
              <div className="ahc-slide-item__flechas">
                <button className="ahc-flecha-btn" onClick={()=>moverOrden(idx,-1)} disabled={idx===0} title="Subir"><IconArrowUp/></button>
                <button className="ahc-flecha-btn" onClick={()=>moverOrden(idx,1)}  disabled={idx===slides.length-1} title="Bajar"><IconArrowDn/></button>
              </div>

              {/* Acciones */}
              <div className="ahc-slide-item__acciones">
                <button className="ahc-icon-btn ahc-icon-btn--edit"  onClick={()=>abrirEditar(slide)} title="Editar"><IconEdit/></button>
                <button className="ahc-icon-btn ahc-icon-btn--trash" onClick={()=>eliminar(slide)}     title="Eliminar"><IconTrash/></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ══════════════════════════════
          MODAL EDITAR / NUEVO
      ══════════════════════════════ */}
      {modal !== null && (
        <div className="ahc-overlay" onClick={()=>setModal(null)}>
          <div className="ahc-modal" onClick={e=>e.stopPropagation()}>

            {/* Cabecera modal */}
            <div className="ahc-modal__head">
              <div>
                <h2>{modal==='nuevo' ? 'Nuevo slide' : 'Editar slide'}</h2>
                <p style={{fontSize:'.82rem',color:'#5a6a63',marginTop:'.15rem'}}>
                  {form.modo==='contenido' ? 'Slide con texto, CTAs y card lateral' : 'Slide de imagen a pantalla completa'}
                </p>
              </div>
              <div style={{display:'flex',gap:'.5rem',alignItems:'center'}}>
                <button className="ahc-btn-ghost" onClick={()=>setPreview(p=>!p)}>
                  <IconEye/> {preview ? 'Editar' : 'Preview'}
                </button>
                <button className="ahc-modal__close" onClick={()=>setModal(null)}><IconClose/></button>
              </div>
            </div>

            {/* ── PREVIEW ── */}
            {preview && (
              <div className="ahc-preview-wrap">
                <div className={'ahc-preview ' + (form.bg_clase||'slide--cursos')} style={
                  form.imagen_url && form.modo==='imagen'
                    ? {backgroundImage:`url(${form.imagen_url})`,backgroundSize:'cover',backgroundPosition:form.imagen_position||'center'}
                    : form.imagen_url && form.modo==='contenido'
                    ? {backgroundImage:`url(${form.imagen_url})`,backgroundSize:'cover',backgroundPosition:form.imagen_position||'center'}
                    : {}
                }>
                  {form.modo==='contenido' && (
                    <div className="ahc-preview__content">
                      {form.tag && <span className="ahc-preview__tag">{form.tag}</span>}
                      {form.subtitulo && <p className="ahc-preview__sub">{form.subtitulo}</p>}
                      <h2 className="ahc-preview__titulo">{form.titulo || 'Título del slide'}</h2>
                      {form.descripcion && <p className="ahc-preview__desc">{form.descripcion}</p>}
                      {(form.items||[]).filter(Boolean).length > 0 && (
                        <ul className="ahc-preview__items">
                          {(form.items||[]).filter(Boolean).map((it,i)=>(<li key={i}>✓ {it}</li>))}
                        </ul>
                      )}
                      <div className="ahc-preview__btns">
                        {form.btn1_texto && <span className="ahc-preview__btn ahc-preview__btn--1">{form.btn1_texto}</span>}
                        {form.btn2_texto && <span className="ahc-preview__btn ahc-preview__btn--2">{form.btn2_texto}</span>}
                      </div>
                    </div>
                  )}
                  {form.modo==='imagen' && !form.imagen_url && (
                    <div className="ahc-preview__no-img"><IconImage/><p>Sube una imagen para ver el preview</p></div>
                  )}
                </div>
                <p className="ahc-preview__nota">Preview aproximado — el diseño final puede variar</p>
              </div>
            )}

            {/* ── FORMULARIO ── */}
            {!preview && (
              <div className="ahc-modal__body">

                {/* Selector de modo */}
                <div className="ahc-field ahc-field--full">
                  <label>Tipo de slide</label>
                  <div className="ahc-modo-selector">
                    <button
                      className={'ahc-modo-btn ' + (form.modo==='contenido'?'ahc-modo-btn--active':'')}
                      onClick={()=>setF('modo','contenido')}
                    >
                      <span>📝</span>
                      <div><strong>Slide de contenido</strong><small>Título, texto, checklist, botones CTA y card lateral</small></div>
                    </button>
                    <button
                      className={'ahc-modo-btn ' + (form.modo==='imagen'?'ahc-modo-btn--active':'')}
                      onClick={()=>setF('modo','imagen')}
                    >
                      <span>🖼️</span>
                      <div><strong>Imagen a pantalla completa</strong><small>Banner simple — imagen que ocupa todo el slide</small></div>
                    </button>
                  </div>
                </div>

                {/* Activo */}
                <div className="ahc-field ahc-field--full">
                  <label className="ahc-checkbox-label">
                    <input type="checkbox" checked={!!form.activo} onChange={e=>setF('activo',e.target.checked)}/>
                    <span>Slide activo (visible en el sitio)</span>
                  </label>
                </div>

                {/* ══ MODO CONTENIDO ══ */}
                {form.modo === 'contenido' && (<>

                  <div className="ahc-separator">Textos</div>

                  <div className="ahc-field">
                    <label>Tag / etiqueta pequeña</label>
                    <input type="text" placeholder="Ej: Formación especializada" value={form.tag||''} onChange={e=>setF('tag',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Subtítulo (sobre el título)</label>
                    <input type="text" placeholder="Ej: No solo teoría." value={form.subtitulo||''} onChange={e=>setF('subtitulo',e.target.value)}/>
                  </div>
                  <div className="ahc-field ahc-field--full">
                    <label>Título principal <span className="ahc-req">*</span></label>
                    <textarea rows={2} placeholder="Ej: Aprende exactamente qué hacer en terapia" value={form.titulo||''} onChange={e=>setF('titulo',e.target.value)}/>
                    <small>Usa \n para salto de línea dentro del título</small>
                  </div>
                  <div className="ahc-field ahc-field--full">
                    <label>Descripción / párrafo</label>
                    <textarea rows={3} placeholder="Descripción del slide…" value={form.descripcion||''} onChange={e=>setF('descripcion',e.target.value)}/>
                  </div>

                  <div className="ahc-separator">Checklist de beneficios</div>
                  <div className="ahc-field ahc-field--full">
                    <div className="ahc-items-lista">
                      {(form.items||['']).map((item,i)=>(
                        <div key={i} className="ahc-item-row">
                          <input type="text" placeholder={`Beneficio ${i+1}`} value={item} onChange={e=>setItem(i,e.target.value)}/>
                          <button className="ahc-item-del" onClick={()=>removeItem(i)} title="Eliminar"><IconTrash/></button>
                        </div>
                      ))}
                      <button className="ahc-item-add" onClick={addItem}><IconPlus/> Agregar item</button>
                    </div>
                  </div>

                  <div className="ahc-separator">Botones CTA</div>
                  <div className="ahc-field">
                    <label>Botón primario — texto</label>
                    <input type="text" placeholder="Ej: Ver Cursos" value={form.btn1_texto||''} onChange={e=>setF('btn1_texto',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Botón primario — link</label>
                    <input type="text" placeholder="/formaciones" value={form.btn1_link||''} onChange={e=>setF('btn1_link',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Botón secundario — texto</label>
                    <input type="text" placeholder="Ej: Explorar gratis" value={form.btn2_texto||''} onChange={e=>setF('btn2_texto',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Botón secundario — link</label>
                    <input type="text" placeholder="/formaciones#gratuitos" value={form.btn2_link||''} onChange={e=>setF('btn2_link',e.target.value)}/>
                  </div>

                  <div className="ahc-separator">Card lateral derecha</div>
                  <div className="ahc-field">
                    <label>Título de la card</label>
                    <input type="text" placeholder="Ej: Evaluación del Lenguaje" value={form.card?.titulo||''} onChange={e=>setCard('titulo',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Precio / tag de la card</label>
                    <input type="text" placeholder="Ej: S/. 120" value={form.card?.precio||''} onChange={e=>setCard('precio',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Estadística</label>
                    <input type="text" placeholder="Ej: 320 estudiantes inscritos" value={form.card?.stat||''} onChange={e=>setCard('stat',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Badge 1</label>
                    <input type="text" placeholder="Ej: ★ 4.9 valoración" value={form.card?.badge1||''} onChange={e=>setCard('badge1',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Badge 2</label>
                    <input type="text" placeholder="Ej: 🎓 Certificado incluido" value={form.card?.badge2||''} onChange={e=>setCard('badge2',e.target.value)}/>
                  </div>

                  <div className="ahc-separator">Fondo</div>
                  <div className="ahc-field ahc-field--full">
                    <label>Color / estilo de fondo</label>
                    <div className="ahc-bg-selector">
                      {BG_OPCIONES.map(bg=>(
                        <button
                          key={bg.clase}
                          className={'ahc-bg-opt ' + (form.bg_clase===bg.clase?'ahc-bg-opt--active':'')}
                          onClick={()=>setF('bg_clase',bg.clase)}
                          title={bg.label}
                        >
                          <div className="ahc-bg-opt__color" style={{background:bg.color}}/>
                          <span>{bg.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="ahc-field ahc-field--full">
                    <label>Imagen de fondo opcional (se superpone al color)</label>
                    {form.imagen_url && form.modo==='contenido' && (
                      <div className="ahc-img-preview">
                        <img src={form.imagen_url} alt="Fondo"/>
                        <button className="ahc-img-remove" onClick={()=>setF('imagen_url','')}><IconTrash/> Quitar</button>
                      </div>
                    )}
                    <button className="ahc-upload-btn" onClick={()=>fileRef.current?.click()} disabled={subiendo}>
                      <IconImage/> {subiendo ? 'Subiendo…' : form.imagen_url&&form.modo==='contenido' ? 'Cambiar imagen' : 'Subir imagen de fondo'}
                    </button>
                  </div>
                </>)}

                {/* ══ MODO IMAGEN ══ */}
                {form.modo === 'imagen' && (<>

                  <div className="ahc-separator">Imagen principal</div>

                  {form.imagen_url ? (
                    <div className="ahc-field ahc-field--full">
                      <div className="ahc-img-preview ahc-img-preview--full">
                        <img src={form.imagen_url} alt="Slide"/>
                        <button className="ahc-img-remove" onClick={()=>setF('imagen_url','')}><IconTrash/> Quitar imagen</button>
                      </div>
                    </div>
                  ) : (
                    <div className="ahc-field ahc-field--full">
                      <div className="ahc-upload-zone" onClick={()=>fileRef.current?.click()}>
                        <IconImage/>
                        <p><strong>Haz clic para subir la imagen</strong></p>
                        <small>JPG, PNG, WEBP — máx. 8MB — recomendado: 1920×600px</small>
                        {subiendo && <p style={{color:'#4db88a',marginTop:'.5rem'}}>Subiendo…</p>}
                      </div>
                    </div>
                  )}

                  <div className="ahc-field">
                    <label>Posición de la imagen</label>
                    <select value={form.imagen_position||'center'} onChange={e=>setF('imagen_position',e.target.value)}>
                      {POS_OPCIONES.map(p=>(<option key={p} value={p}>{p}</option>))}
                    </select>
                  </div>
                  <div className="ahc-field">
                    <label>Link al hacer clic (opcional)</label>
                    <input type="text" placeholder="Ej: /formaciones o https://…" value={form.imagen_link||''} onChange={e=>setF('imagen_link',e.target.value)}/>
                  </div>
                  <div className="ahc-field">
                    <label>Título interno (solo para identificar en admin)</label>
                    <input type="text" placeholder="Ej: Banner promo mayo" value={form.titulo||''} onChange={e=>setF('titulo',e.target.value)}/>
                  </div>

                  {form.imagen_url && (
                    <div className="ahc-field ahc-field--full">
                      <button className="ahc-upload-btn" onClick={()=>fileRef.current?.click()} disabled={subiendo}>
                        <IconImage/> {subiendo ? 'Subiendo…' : 'Cambiar imagen'}
                      </button>
                    </div>
                  )}
                </>)}

                {/* Input file oculto */}
                <input
                  ref={fileRef} type="file" accept="image/*"
                  style={{display:'none'}}
                  onChange={e=>subirImagen(e.target.files?.[0])}
                />

              </div>
            )}

            {/* Footer modal */}
            <div className="ahc-modal__foot">
              <button className="ahc-btn-ghost" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="ahc-btn-primary" onClick={guardar} disabled={guardando}>
                {guardando ? 'Guardando…' : <><IconCheck/> Guardar slide</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}